import React from "react";

export const SectionEyebrow = ({ children, light = false, ...rest }) => (
  <span
    className={`eyebrow ${light ? "text-gold" : "text-gold-500"}`}
    {...rest}
  >
    {children}
  </span>
);

export const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = "left",
  light = false,
  className = "",
  ...rest
}) => (
  <div
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}
    {...rest}
  >
    {eyebrow ? <SectionEyebrow light={light}>{eyebrow}</SectionEyebrow> : null}
    <h2
      className={`mt-3 font-display tracking-tight text-3xl sm:text-4xl lg:text-5xl font-light ${
        light ? "text-white" : "text-navy"
      }`}
    >
      {title}
    </h2>
    {description ? (
      <p
        className={`mt-5 text-base sm:text-lg leading-relaxed ${
          light ? "text-white/70" : "text-slate-600"
        }`}
      >
        {description}
      </p>
    ) : null}
  </div>
);

export default SectionHeading;
